<template>
  <div>
    <el-row>
			<el-col :span="18">
				<h3>Additional Questions</h3>
				<span class="description"
					>Manage additional questions</span
				>
			</el-col>
		</el-row>
		<el-divider></el-divider>
		<el-row type="flex" justify="end" class="mt-2">
			<el-col :offset="14" :span="10" class="d-flex flex-justify-end">
        <el-button type="primary" @click="$router.push({name: 'additional-questions.create'})">Add Additional Questions</el-button>
			</el-col>
		</el-row>
    <el-row class="mt-1">
      <el-col :span="18">
        <el-tag
          closable
          v-if="searching"
          @close="reset()"
          key="search"
          class="mr-2"
          type="success">
          {{ lastSearch }}
        </el-tag>
        <el-tag
          closable
          v-if="selectedRole"
          key="search"
          type="success">
          {{ getRoleName(selectedRole.roleType) }}
        </el-tag>
      </el-col>
      <el-col :span="6" class="d-flex flex-justify-end" v-if="selectedRole">
        <el-button type="primary" icon="el-icon-check" @click="submitRoles"
					>Apply</el-button
				>
			</el-col>
    </el-row>
    <data-tables-server
      ref="userTable"
      :table-props="{
        border: false,
        'max-height': 800,
        'reserve-selection': true
      }"
      :pagination-props="{
        pageSizes: [20, 50, 100],
      }"
      :current-page.sync="page"
      :page-size="pageSize"
      :data="tableData"
      :total="total"
      @query-change="queryChange"
      @row-click="goToRow"
      @selection-change="handleSelectionChange"
      class="mt-1"
      row-key="_id"
      :key="key"
    >
      <el-table-column type="selection" v-if="selectedRole" width="55"></el-table-column>
      <el-table-column prop="_id" :label="idLabel" width="180" sortable/>
      <el-table-column prop="name" label="Name" sortable="custom" />
    </data-tables-server>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import { validateEmail } from '@/utils/validators';
import { errormsg } from '@/utils/constants';
import { timedate } from '@/utils/timedate';
import { getRoleName } from '@/utils/roles';

export default {
  data() {
    const {
      lastSearch,
      searching,
      criteria,
      filters,
      data: tableData,
      pagination: { total, pageSize, page },
    } = this.$store.state.members;

    return {
      getRoleName,
      lastSearch,
      criteria,
      tableData,
      queryInfo: {},
      pageSize,
      page,
      total,
      filters,
      searching,
      addRoleDialogVisible: false,
      selectedRole: undefined,
      selectedUsers: [],
      key: 0,
      usersWithRole: [],
      usersToBeRemove: [],
    };
  },
  computed: {
    idLabel() {
      return 'ID';
    },
    getSelectedUsers() {
      return this.$store.getters['user/getSelectedUsers'];
    },
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    isAddRoleVisibile() {
      const allowedRoles = [1, 2, 3];
      return _.includes(allowedRoles, this.clearance);
    },
  },
  mounted() {
    this.$store.commit('loading', true);
    this.criteria.onLoad = true;

    this.search(this.criteria);

    this.criteria.onLoad = false;
    this.$store.commit('loading', false);
  },
  methods: {
    reset() {
      this.searching = false;
      this.criteria.firstName = undefined;
      this.criteria.lastName = undefined;
      this.criteria.email = undefined;
      this.criteria.onLoad = true;
      this.lastSearch = undefined;
      this.search(this.criteria);
    },
    queryChange(queryInfo) {
      this.queryInfo = queryInfo;
      if (this.criteria.email || (this.criteria.firstName && this.criteria.lastName)) {
        this.search(this.criteria);
      }

      if (this.queryInfo) {
        _.assign(this.criteria, { sort: this.queryInfo.sort || {}, onLoad: true });
        this.search(this.criteria);
      }
    },
    goToRow(row) {
      this.$router.push(`/additional-questions/${row._id}`);
    },
    memberTypes(r, c, v) {
      return _.join(_.uniq(_.map(v, (rego) => _.capitalize(rego.memberType))), ', ');
    },
    dateFormatter(r, c, v) {
      return v ? timedate.set(v).fDateTime() : '';
    },
    dateOnlyFormatter(r, c, v) {
      return v ? timedate.set(v).fDate() : '';
    },
    getLastSearch(criterias) {
      const firstName = criterias.firstName ? `${criterias.firstName}` : '';
      const lastName = criterias.lastName ? ` ${criterias.lastName}` : '';
      const email = criterias.email ? ` ${criterias.email}` : '';
      const searches = Object.values(criterias, ([value]) => value !== undefined);
      const lastSearch = searches.filter((search) => search !== undefined);
      return lastSearch.length > 0 ? `${firstName}${lastName}${email}` : this.reset();
    },
    searchCriteria() {
      const { email } = this.criteria;
      if (email && !validateEmail(email)) {
        this.$message.error(errormsg.email);
        return;
      }
      this.search(this.criteria);
      this.searching = true;
      this.lastSearch = this.getLastSearch(this.criteria);
    },
    search(body) {
      this.$store.commit('loading', true);
      const { pageSize, page } = this.queryInfo;
      this.$http.post(`/assemble/api/v1/admin/additional-questions/data-table/${pageSize}/${page}/`, body)
        .then((response) => {
          const { total, pageData } = response.data.data;
          this.total = total;
          this.tableData = pageData;
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    handleSelectionChange(val) {
      // add to list of will be remove if uncheck
      this.usersToBeRemove = _.difference(this.usersWithRole, val);

      this.selectedUsers = _.difference(val, this.usersWithRole);
    },
    setSelectedRoles(role) {
      this.key++;
      this.addRoleDialogVisible = false;
      this.selectedRole = role;
    },
    submitRoles() {
      this.$store.commit('loading', true);
      // get only those entity have value
      const userIds = _.map((this.selectedUsers), (user) => user._id);
      const removeUserIds = _.map((this.usersToBeRemove), (user) => user._id);
      const {
        roleType, entityType, entityId, restriction
      } = this.selectedRole;
      const body = {
        userIds,
        removeUserIds,
        roleType,
        entityType,
        entityId,
        restriction
      };
      this.$http.post('/assemble/api/v1/admin/users/bulk-roles', body)
        .then((res) => {
          this.$message.success('Successful');
          this.$store.commit('loading', false);
          this.search(this.criteria);
          this.selectedRole = undefined;
          this.selectedUsers = [];
        }).catch((error) => {
          this.$message.error(error.response.data.message);
          this.$store.commit('loading', false);
        });
    },
  },
  watch: {
    tableData(data) {
    //   this.$store.commit('members/updateData', {
    //     data
    //   });
    //   this.$store.commit('members/updatePagination', {
    //     pagination: {
    //       ..._.pick(this.queryInfo, ['pageSize', 'page']),
    //       total: this.total,
    //     }
    //   });
    //   this.$store.commit('members/updateSearching', {
    //     searching: this.searching,
    //   });
      if (this.selectedRole) {
        const { entityId, roleType } = this.selectedRole;
        const hasRoles = [];
        _.each(this.tableData, (d) => {
          const user = _.find((d.roles), (role) => _.get(role, 'entity._id') === entityId && _.get(role, 'type') === roleType);

          if (user) hasRoles.push(d);
        });

        // Calling the method in the nested child component
        if (hasRoles.length) {
          this.usersWithRole = hasRoles;

          this.$nextTick(() => {
            _.forEach((hasRoles), (row) => {
              this.$refs.userTable.$refs.elTable.toggleRowSelection(row);
            });
          });
        }
      }

      this.$store.commit('members/updateLastSearch', {
        lastSearch: this.lastSearch,
      });
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-pagination {
  margin-top: 2rem !important;
}
</style>
